import React from 'react';
import './style-modal.less';

export default function DeleteModal() {
  return (
    <div className="delete-modal">Are you sure you want to delete this?</div>
  );
}
